import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const index = props => {
  const { html } = props;
  return (
    <div id={'TopBanner'}
         className='element-box alert-warning'
         dangerouslySetInnerHTML={{ __html: html }}/>
  );
};


index.defaultProps = {};

index.propTypes = {
  html: PropTypes.any.isRequired,
};

export default index;
